import { getSegment } from "./helpers";

/**
 * Track when a Personalized Experience is viewed
 * @param {import('../personalization/global-rules').PersonalizationRule} rule
 */
export function trackPersonalizationViewed(rule) {
  const props = {
    personalizationId: rule.id,
    personalizationName: rule.name,
  };
  getSegment("track")("Personalization Viewed", props);
}
